import React, { useState } from 'react';
import { Shield, Mail, KeyRound, Loader2, ArrowRight } from 'lucide-react';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const STEP = { EMAIL: 'email', OTP: 'otp' };

export default function SuperAdminLogin({ onLogin }) {
  const [step, setStep] = useState(STEP.EMAIL);
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleRequestOTP = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await fetch(`${API_URL}/superadmin/request-otp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      setStep(STEP.OTP);
    } catch (e) { setError(e.message); }
    finally { setLoading(false); }
  };

  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await fetch(`${API_URL}/superadmin/verify-otp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, code })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      localStorage.setItem('sa_token', data.token);
      onLogin(data.email);
    } catch (e) { setError(e.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-violet-900 to-slate-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-3 mb-4">
            <div className="bg-violet-600 p-3 rounded-xl shadow-xl">
              <Shield className="text-white" size={28} />
            </div>
            <span className="text-white font-black text-3xl tracking-tighter">iOffer <span className="text-violet-300">Admin</span></span>
          </div>
          <p className="text-slate-400">Superadmin-panel</p>
        </div>

        <div className="bg-white rounded-2xl shadow-2xl p-8">
          {step === STEP.EMAIL && (
            <>
              <h2 className="text-2xl font-black mb-6">Logga in som superadmin</h2>
              <form onSubmit={handleRequestOTP} className="space-y-4">
                <div>
                  <label className="text-xs font-bold text-slate-500 uppercase">E-postadress</label>
                  <div className="relative mt-1">
                    <Mail className="absolute left-3 top-3.5 text-slate-400" size={18} />
                    <input type="email" required value={email} onChange={e => setEmail(e.target.value)}
                      className="w-full pl-10 pr-4 py-3 border border-slate-200 rounded-xl outline-none focus:ring-2 focus:ring-violet-500"
                      placeholder="din@epost.se" />
                  </div>
                </div>
                {error && <p className="text-red-600 text-sm bg-red-50 p-3 rounded-lg">{error}</p>}
                <button type="submit" disabled={loading}
                  className="w-full bg-violet-600 text-white py-3 rounded-xl font-black flex items-center justify-center gap-2">
                  {loading ? <Loader2 className="animate-spin" size={20} /> : <><span>Skicka kod</span><ArrowRight size={18} /></>}
                </button>
              </form>
            </>
          )}

          {step === STEP.OTP && (
            <>
              <h2 className="text-2xl font-black mb-2">Ange din kod</h2>
              <p className="text-slate-500 text-sm mb-6">Koden skickades till {email}</p>
              <form onSubmit={handleVerifyOTP} className="space-y-4">
                <div>
                  <label className="text-xs font-bold text-slate-500 uppercase">6-siffrig kod</label>
                  <div className="relative mt-1">
                    <KeyRound className="absolute left-3 top-3.5 text-slate-400" size={18} />
                    <input type="text" inputMode="numeric" maxLength={6} required value={code}
                      onChange={e => setCode(e.target.value.replace(/\D/g, ''))}
                      className="w-full pl-10 pr-4 py-3 border border-slate-200 rounded-xl outline-none focus:ring-2 focus:ring-violet-500 font-mono text-2xl tracking-widest text-center"
                      placeholder="000000" />
                  </div>
                </div>
                {error && <p className="text-red-600 text-sm bg-red-50 p-3 rounded-lg">{error}</p>}
                <button type="submit" disabled={loading || code.length !== 6}
                  className="w-full bg-violet-600 text-white py-3 rounded-xl font-black flex items-center justify-center gap-2 disabled:opacity-50">
                  {loading ? <Loader2 className="animate-spin" size={20} /> : 'Logga in'}
                </button>
                <button type="button" onClick={() => { setStep(STEP.EMAIL); setCode(''); setError(''); }}
                  className="w-full text-slate-400 text-sm py-2">Tillbaka</button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
